import { NOTIFICATION } from 'constants/store.constants';

export const selectNotifications = (state) => state[NOTIFICATION];
